const api = process.env.REACT_APP_API;

export const fetchRepositoriesWithContributors = async (page: number = 1) => {
  const res = await fetch(`${api}/contributors?page=${page}`);
  return await res.json();
};

export const fetchRepositoriesDetails = async (name: string) => {
  const res = await fetch(`${api}/${name}/contributors`);
  return await res.json();
};

export const fetchContributorDetails = async (username: string) => {
  const res = await fetch(`${api}/${username}/reposContributed`);
  return await res.json();
};
